import React, { useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import RssSourceManagement from '../../components/admin/scrape/RssSourceManagement';
import ScrapeTaskManagement from '../../components/admin/scrape/ScrapeTaskManagement';
import ScrapeSessionManagement from '../../components/admin/scrape/ScrapeSessionManagement';
import ScrapeTemplateManagement from '../../components/admin/scrape/ScrapeTemplateManagement';
import ScrapeDataViewer from '../../components/admin/scrape/ScrapeDataViewer';
import ScrapeLogViewer from '../../components/admin/scrape/ScrapeLogViewer';

const ScrapeManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('rss');

  const tabs = [
    { id: 'rss', name: 'RSS管理', component: <RssSourceManagement /> },
    { id: 'tasks', name: '采集任务', component: <ScrapeTaskManagement /> },
    { id: 'sessions', name: '会话配置', component: <ScrapeSessionManagement /> },
    { id: 'templates', name: '采集模板', component: <ScrapeTemplateManagement /> },
    { id: 'data', name: '数据查看', component: <ScrapeDataViewer /> },
    { id: 'logs', name: '系统日志', component: <ScrapeLogViewer /> }
  ];

  return (
    <AdminLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">采集模块管理</h1>
          <p className="text-gray-600">网页数据采集系统的完整管理平台</p>
        </div>

        {/* 标签页导航 */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>

        {/* 标签页内容 */}
        <div className="mt-6">
          {tabs.find(tab => tab.id === activeTab)?.component}
        </div>
      </div>
    </AdminLayout>
  );
};

export default ScrapeManagement;